//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './FaqClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetByIdFaqQueryParameters = {
  id: number;
};

    
export function createFaqUrl(studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/faq?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createFaqMutationKey(studyId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'FaqClient',
      'createFaq',
      studyId as any,
    ]);
}

/**
 * Creates new Faq entity for the Study.
 * @param layout Schema of the FAQ
 * @param studyId (optional) Id of the study
 */
export function useCreateFaqMutation<TContext>(studyId?: number | undefined, options?: Omit<UseMutationOptions<Types.FaqDto, unknown, { [key: string]: any; }, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FaqDto, unknown, { [key: string]: any; }, TContext> {
  const key = createFaqMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((layout: { [key: string]: any; }) => Client.createFaq(layout, studyId), {...options, mutationKey: key});
}
  
    
export function putFaqUrl(id?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/faq?";
if (id === null)
    throw new Error("The parameter 'id' cannot be null.");
else if (id !== undefined)
    url_ += "id=" + encodeURIComponent("" + id) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function putFaqMutationKey(id?: number | undefined): MutationKey {
  return trimArrayEnd([
      'FaqClient',
      'putFaq',
      id as any,
    ]);
}

/**
 * Update existed Faq
 * @param layout Schema of the FAQ
 * @param id (optional) Id of the FAQ
 */
export function usePutFaqMutation<TContext>(id?: number | undefined, options?: Omit<UseMutationOptions<Types.FaqDto, unknown, { [key: string]: any; }, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FaqDto, unknown, { [key: string]: any; }, TContext> {
  const key = putFaqMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((layout: { [key: string]: any; }) => Client.putFaq(layout, id), {...options, mutationKey: key});
}
  
    
export function getByIdUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/faq/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getByIdDefaultOptions: UseQueryOptions<Types.FaqDto, unknown, Types.FaqDto> = {
  queryFn: __getById,
};
export function getGetByIdDefaultOptions(): UseQueryOptions<Types.FaqDto, unknown, Types.FaqDto> {
  return getByIdDefaultOptions;
};
export function setGetByIdDefaultOptions(options: UseQueryOptions<Types.FaqDto, unknown, Types.FaqDto>) {
  getByIdDefaultOptions = options;
}

export function getByIdQueryKey(id: number): QueryKey;
export function getByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetByIdFaqQueryParameters;

    return trimArrayEnd([
        'FaqClient',
        'getById',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'FaqClient',
        'getById',
        ...params
      ]);
  }
}
function __getById(context: QueryFunctionContext) {
  return Client.getById(
      context.queryKey[2] as number    );
}

export function useGetByIdQuery<TSelectData = Types.FaqDto, TError = unknown>(dto: GetByIdFaqQueryParameters, options?: UseQueryOptions<Types.FaqDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Return entity of the Faq
 * @param id Form Id.
 */
export function useGetByIdQuery<TSelectData = Types.FaqDto, TError = unknown>(id: number, options?: UseQueryOptions<Types.FaqDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetByIdQuery<TSelectData = Types.FaqDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FaqDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetByIdFaqQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.FaqDto, TError, TSelectData>({
    queryFn: __getById,
    queryKey: getByIdQueryKey(id),
    ...getByIdDefaultOptions as unknown as UseQueryOptions<Types.FaqDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Return entity of the Faq
 * @param id Form Id.
 */
export function setGetByIdData(queryClient: QueryClient, updater: (data: Types.FaqDto | undefined) => Types.FaqDto, id: number) {
  queryClient.setQueryData(getByIdQueryKey(id),
    updater
  );
}

/**
 * Return entity of the Faq
 * @param id Form Id.
 */
export function setGetByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FaqDto | undefined) => Types.FaqDto) {
  queryClient.setQueryData(queryKey, updater);
}